var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    fillRule: "evenodd",
    d: "M0 0h132.292v132.292H0z",
    paintOrder: "fill markers stroke"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#02706c",
    d: "M90.029 73.237s2.86 3.863 2.516 2.406c-.344-1.457-2.517-7.268-2.517-7.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffefe",
    d: "M68.525 74.393s-5.431 25.68-5.033 32.58c.398 6.901 7.628 2.885 7.628 2.885s1.937-29.191 6.369-31.328c4.432-2.138-8.964-4.137-8.964-4.137z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d4c31",
    d: "M69.26 75.808s-1.48.386-1.639 3.09c-.158 2.703.323-2.31 2.172-2.717 1.85-.407-.532-.373-.532-.373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b66f27",
    d: "M86.421 91.83s-7.77-6.77-7.31-12.56c.461-5.79 5.936 1.735 5.936 1.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b4b1a",
    d: "M69.239 82.14s-2.834-.466-4.026 2.827c-1.192 3.293 1.009-.15 1.009-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b66f27",
    d: "M73.61 78.087s-1.397 2.046-3.36 2.951c-1.963.906-4.75 2.632-5.045 5.604-.295 2.973 1.027-4.64 5.785-4.138 4.758.503 3.644 1.396 3.644 1.396l.714-.54s-1.336-1.791-2.636-1.975c-1.301-.183 2.143-2.665 2.143-2.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0ea49d",
    d: "M70.84 36.642s24.272 16.984 18.55 40.546c0 0-3.328 4.44-2.23 17.348 0 0-7.053-13.774-3.953-16.563 3.1-2.79-16.253-32.036-16.253-32.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2ab2d0",
    d: "M63.465 23.054c-13.039-.019-18.689 13.575-18.689 13.575.466-.358 4.41 6.073 5.499 5.918l11.52-.088s11.452 2.003 10.434-7.092c-1.018-9.095-7.493-12.14-7.493-12.14-.955-.135-.401-.172-1.27-.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb873e",
    d: "M50.104 43.152S41.939 50.548 60.42 68.26c18.447 17.679 21.995 11.732 21.94 11.784l3.304-4.235-23.87-33.35s-10.156-3.68-11.691.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd7933",
    d: "M52.966 42.14c-1.205.292-2.153.914-2.483 2.08 0 0-7.282 7.567 10.888 23.899 2.915 2.62 5.435 4.659 7.62 6.247 1.21.42 1.955.629 1.182.192-2.03-1.144 1.49.422.634-.32-.856-.743-2.304-3.156-1.645-2.649.659.507-1.635-2.49-.96-2.148.634.321-1.131-3.702-.896-3.698-.461-.488-1.79-2.023-1.676-2.75.152-.977.681-2.628.681-2.628l-6.045-11.318-.505-6.491a29.462 29.462 0 00-.491-.111zm14.341 23.603c.159.168.217.215.074.057-.034-.038-.058-.056-.074-.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad7130",
    d: "M52.728 42.173c-1.15.17-2.086.653-2.444 1.675 0 0-4.359 3.952 1.949 13.113l.514.402s1.015-5.336.906-3.156c-.109 2.181 1.134-3.434 1.41-2.01.275 1.424.72-1.945.63-.656-.09 1.29.431-1.993.742-.858.31 1.134.494-.682.494-.682l1.787-5.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02928c",
    d: "M59.92 42.238S46.564 53.599 86.22 78.83c0 0 2.662 1.963 3.06.998.397-.964-1.78-4.465-1.105-4.92.675-.455.326-6.79-.092-7.738-.418-.947-.43-3.517-1.833-7.596-1.404-4.08-7.421-14.293-9.244-13.923-1.822.37-2.653-4.044-7.509-7.072-4.855-3.028-9.578 3.658-9.578 3.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02706c",
    d: "M87.843 76.54c-.05-.016-.066.04-.037.19.227 1.195-3.639 1.156-3.639 1.156l.103.173c.56.365 1.13.732 1.713 1.103 0 0 2.663 1.963 3.06.998.24-.583-.456-2.087-.898-3.29-.135-.185-.244-.311-.302-.33zM87.843 75.024s.333-3.64-.577-5.052c-.911-1.413-5.345-2.317-5.415-4.671 0 0 .35 2.083 1.984 3.307 1.634 1.224 4.275 5.972 4.096 6.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M68.158 105.995c-.209.067.41 1.541-.919.766-1.284-.75-2.963.576-3.63 1.183 1.003 5.498 7.444 1.95 7.5 1.92 0-.174.015-.35.049-.532.018-.255.033-.463.082-1.086-.566.5-1.042.727-.811-.238.625-2.613-1.054-.833-1.961-1.79-.17-.179-.262-.238-.31-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M68.222 106.327c-.172.036.121 1.431-.82.583-.912-.82-2.404.18-3.007.65.072 5.057 5.595 2.6 5.643 2.58a2.86 2.86 0 01.107-.473c.047-.227.086-.412.206-.967-.51.385-.913.535-.606-.306.831-2.277-.72-.868-1.308-1.831-.11-.181-.175-.245-.215-.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107f7c",
    d: "M66.44 44.315s2.914 1.162 2.233 4.52c-.68 3.357 1.452-.82.98-2.609-.473-1.79 3.885 2.917 2.873 6.3-1.012 3.382 2.137-.616 1.612-2.849-.526-2.233-1.79-4.84-1.042-4.488.75.352-6.483-1.911-6.483-1.911z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107f7c",
    d: "M68.125 45.905s2.623.7 2.288 3.468c-.335 2.769 1.199-.78.651-2.188-.547-1.407 3.6 2.037 2.98 4.853-.622 2.816 1.81-.673 1.183-2.433-.628-1.761-1.927-3.763-1.249-3.54.679.222-5.781-1.012-5.781-1.012zM61.304 43.338c-.14-.117-5.561.453 2.605 15.017 7.254 12.937-4.832-9.235-2.857-12.326 1.947-3.045 3.128-4.747.252-2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#098684",
    d: "M76.913 69.101c-.308.024-.525.344-.677.703.806 1.346 2.688 3.278 6.67 6.004 8.81 6.03-5.018-3.676-5.76-6.669a.552.552 0 00-.233-.038zM77.501 61.226c-.26-.045.05 1.052-.453.836-.218-.093-.276.214-.27.663 1.041 2.528 3.14 6.011 7.088 10.79 9.664 11.699-4.121-5.42-6.078-12.047-.135-.158-.227-.232-.287-.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5a5a",
    d: "M45.289 37.042c-9.932 7.48-17.481 16.34-14.63 14.682C46.475 43.707 52.42 39.416 52.42 39.416c1.718-1.99-1.89-.876-1.89-.876-7.334 1.42-5.242-1.498-5.242-1.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M51.356 39.1s-11.919 5.145-19.567 11.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M45.043 39.269a.177.177 0 00-.063.031s-2.838 2.856-5.035 4.627a840.249 840.249 0 015.327-3.525s.061-1.202-.23-1.133zm-5.098 4.658l-.074.05.01.002.064-.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#367486",
    d: "M50.66 36.487s.194-1.575 1.095-1.812c.9-.237 1.968-.45 2.362-.948.394-.496.527-1.46 1.84-1.66 1.312-.2 2.117.795 2.117.795s.66 1.815-.683 2.976-4.061.071-4.061.071.4-1.02.226-1.004c-.174.017-2.014-.203-2.895 1.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02706c",
    d: "M59.403 43.143s1.694-2.865 7.495 2.249c0 0 .914-3.516 7.854 2.097 6.94 5.613 7.325 6.858 7.325 6.858-.423.787-10.636-20.687-21.09-13.332 0 0-1.35.787-1.584 2.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#717171",
    d: "M45.479 42.466s4.226-2.613 5.016-2.594c.79.019.014.431.014.431z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfefb",
    d: "M46.006 43.448s7.958-2.237 6.725.458c-1.234 2.695 3.992.082 5.804.148.262.09.59-2.189 3.013-2.107 0 0 .465-.226.043-.66-.423-.433-10.935-2.187-15.585 2.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2499b3",
    d: "M55.857 29.768s4.785-.629 4.154 2.196c-.631 2.825 1.123-.47 1.132-1.287.008-.818-1.11-1.835-1.53-1.75-.421.086 1.239-1.946-3.756.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#415352",
    d: "M44.776 36.629s-.502-12.895 18.477-13.754c0 0 5.551 2.417-2.135 4.585C53.432 29.63 46.906 39.2 46.906 39.2s-2.383.74-2.13-2.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121717",
    fillOpacity: 0.839,
    d: "M56.211 32.648c-1.883-.067-2.475 3.07-2.475 3.07 3.875 2.003 3.994-2.434 3.994-2.434-.58-.434-1.084-.62-1.519-.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b4743d",
    fillOpacity: 0.839,
    d: "M63.75 31.455c-2.916.084-5.05 1.809-5.626 3.408-.658 1.828-5.365 3.588-5.365 3.588s-4.18 1.679.176.41a15.59 15.59 0 002.141-.792c7.238-3.898 7.61-1.976 9.5-1.566 2.635-3.365.216-3.496.216-3.496s3.824-1.003.254-1.483a7.98 7.98 0 00-1.296-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfefb",
    d: "M66.819 32.056c-.486.03-1.121.46-2.028.951 0 0 .944 1.606-.129 2.775-1.072 1.169 3.023 1.213 3.023 1.213s3.514-1.096 3.156-.353c0 0 .943-.232.783-.973-.16-.74-2.715-3.315-4.065-3.16-.21-.345-.449-.471-.74-.453z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.862 34.467s.316-.74.534-.402c.218.339 1.275.453 1.584-.516.309-.97-2.033-.558-2.118.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d08b42",
    d: "M46.906 39.2s2.198-2.993 2.634-3.052c.437-.059 1.348-.15 1.934-.541.586-.392.183 1.28.04 1.276-.14-.004.86-1.022-4.608 2.316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.007 35.393s-1.728.197-.608 1.905c1.12 1.709 1.174-2.608.608-1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455f5d",
    d: "M45.045 36.66c.287.093.44-11.06 15.078-12.82 0 0 4.683 1.965-1.672 4.142-6.355 2.178-11.57 10.892-11.57 10.892s-1.97.735-1.836-2.213z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.0b3cc6a9.svg";
export { ForwardRef as ReactComponent };